import _ from 'lodash'

export const availableServiceGroupsById = state => {
  return _.keyBy(state.availableServiceGroups, 'id')
}



// WEBPACK FOOTER //
// ./src/store/getters/service-groups.js